<script lang="ts">
  import { Button } from '@stickerapp-org/athena/Button';
  import clsx from 'clsx';
  import { KeyboardArrowDown } from '@athena-lib/Icons';
  import type { ButtonExpanderProps } from './types';

  const { useExpander, text, alignment, size, full, children }: ButtonExpanderProps = $props();

  const widthAndHeight = $derived.by(() => {
    const sizes: Record<string, string> = {
      small: clsx('h-5 w-5'),
      medium: clsx('h-6 w-6'),
      large: clsx('h-7 w-7'),
    };
    return sizes[size ?? 'medium'];
  });
  let expanded = $state(false);
</script>

{#if useExpander}
  <div
    class={clsx(
      'flex',
      alignment === 'left'
        ? 'justify-start'
        : alignment === 'center'
          ? 'justify-center'
          : 'justify-end',
    )}
  >
    <Button class="flex" {full} size={size || 'medium'} onClick={() => (expanded = !expanded)}
      >{text}
      <span
        class={clsx(
          expanded && 'rotate-180',
          widthAndHeight,
          'ml-auto transition-transform duration-300',
        )}
      >
        <KeyboardArrowDown />
      </span>
    </Button>
  </div>
  {#if expanded}
    <div class="pt-8">
      {@render children()}
    </div>
  {/if}
{:else}
  {@render children()}
{/if}
